import { mapActions } from 'vuex'
import { MESSAGE_TYPES } from '@/stores/flash'

export default {
  methods: {
    ...mapActions({
      $_flash_addMessage: 'flash/addMessage',
      $_flash_clearMessages: 'flash/clearMessages',
    }),

    $_flash_addErrorMessage(error, text = this.$t('errors.connection'), gtmContext) {
      this.$_flash_addMessage({
        text,
        type: MESSAGE_TYPES.error,
        gtmContext,
      })
      if (error) this.$rollbar.error(error.message, error)
    },

    $_flash_addSuccessMessage(text) {
      this.$_flash_addMessage({ text, type: MESSAGE_TYPES.success })
    },
  },
}
